<script type="text/babel">
export default{
    data () {
        return {
            selectedFamily: this.selectedFamilyProp !== '' ? this.selectedFamilyProp : null,
            urlAllPressReleases: 'press-releases',
            urlFamilyPressReleases: 'press-releases/family/',
        }
    },
    mounted () {
    },
    props: [
        'baseUrl',
        'selectedFamilyProp'
    ],
    computed: {
    },
    methods: {
    },
    watch: {
        selectedFamily: function (newVal, oldVal) {
            let location = this.baseUrl + 'press-releases';
            if (newVal !== 'all') {
                location += '/model-family/' + newVal;
            }
            window.location = location;
        }
    }
}
</script>
